import { makeStyles } from 'makeStyles';

const CONTAINER_WIDTH = 850;
const POINTS_CONTAINER_WIDTH = 560;

export const useStyles = makeStyles()((theme) => ({
  tmxDialog: {
    padding: 0,
  },
  tmxDialogBackdrop: {
    backgroundColor: theme.palette.grey[400],
  },
  tmxDialogPaper: {
    backgroundColor: theme.palette.grey[400],
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  dialogHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    padding: theme.spacing(3),
  },
  dialogTitle: {
    fontSize: 24,
    fontWeight: 900,
    marginBottom: 0,
  },
  dialogSubtitle: {
    fontSize: 16,
  },
  dialogClose: {
    position: 'absolute',
    right: theme.spacing(3),
  },
  dialogContent: {
    backgroundColor: theme.palette.common.white,
    flex: '0 1 auto',
    maxWidth: CONTAINER_WIDTH,
    width: '100%',
    alignSelf: 'center',
    margin: `0 ${theme.spacing(3)} ${theme.spacing(8)} ${theme.spacing(3)}`,
    padding: `${theme.spacing(4)} ${theme.spacing(5)}`,
    borderRadius: 4,
    boxShadow: '0 5px 20px 0 rgba(0, 0, 0, 0.04)',
    border: `solid 1px ${theme.palette.grey[400]}`,
  },
  dialogPlayerWrapper: {
    marginBottom: theme.spacing(3),
  },
  dialogActions: {
    height: 80,
    padding: `0 ${theme.spacing(3)}`,
    backgroundColor: theme.palette.common.white,
    justifyContent: 'center',
    marginTop: 'auto',
  },
  dialogActionsContent: {
    maxWidth: CONTAINER_WIDTH,
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  pointsDialogTitle: {
    marginBottom: theme.spacing(2.5),
    fontSize: 20,
  },
  pointsDialogPaper: {
    width: '100%',
    maxWidth: POINTS_CONTAINER_WIDTH,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(4),
  },
  pointsDialogContent: {
    padding: 0,
    '&:first-of-type': {
      paddingTop: 0,
    },
  },
  pointsDialogActions: {
    padding: 0,
    marginTop: theme.spacing(4),
  },
  addPointButton: {
    marginTop: theme.spacing(3),
  },
  emptyPoints: {
    height: 80,
    borderRadius: 5,
    backgroundColor: theme.palette.grey[200],
    fontSize: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  participantsDialog: {
    width: '100%',
    maxWidth: POINTS_CONTAINER_WIDTH,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    padding: theme.spacing(4),
  },
  participantsDialogHeader: {
    marginBottom: theme.spacing(3),
  },
  participantsDialogContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    padding: 0,
    '&:first-of-type': {
      paddingTop: 0,
    },
  },
  participantsDialogActions: {
    padding: `${theme.spacing(4)} 0 0`,
  },
  selectPlayerButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(2),
    },
  },
  selectPlayerButtonEndIcon: {
    width: 12,
  },
}));
